import { NavLink, ThemeIcon } from '@mantine/core';
import { IconHeadset } from '@tabler/icons';
import { AppRoutePaths } from '../../../utils/enums';

interface SacLinkProps {
  navigate(to: string): void;
  themeColor: 'dark' | 'light';
}

export function SacLink({ navigate, themeColor }: SacLinkProps) {
  return (
    <NavLink
      styles={{
        label: {
          color: themeColor === 'light' ? '#373A40' : '#FBFBFB',
        },
      }}
      label="SAC"
      fw="bold"
      color=""
      icon={
        <ThemeIcon color="blue" variant="light">
          <IconHeadset size={16} />
        </ThemeIcon>
      }
      childrenOffset={28}
    >
      <NavLink
        label="Tickets"
        onClick={() => navigate(AppRoutePaths.SAC_LIST)}
      />
    </NavLink>
  );
}
